"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var types = _interopRequireWildcard(require("../../../constants/galleryTypes"));

var _itemViewActions = require("../../../actions/itemViewActions.js");

var _videoPlayModes = _interopRequireDefault(require("./videoPlayModes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var _default = function _default(_ref) {
  var videoQueue = _ref.videoQueue,
      utils = _ref.utils;
  return function (store) {
    var playVideo = function playVideo(i) {
      store.dispatch({
        type: types.SET_VIDEO_PLAY_INDEX,
        payload: i
      });
    };

    var playCurrentVideo = function playCurrentVideo() {
      playVideo(videoQueue.current());
    };

    var playNextVideo = function playNextVideo() {
      playVideo(videoQueue.next());
    };

    var stopPlaying = function stopPlaying() {
      playVideo(-1);
    };

    return function (next) {
      return function (action) {
        var type = action.type,
            payload = action.payload;

        var _store$getState = store.getState(),
            videoPlayMode = _store$getState.gallery.videoPlayMode; // This doesn't affect autoplay


        switch (type) {
          case types.VIDEO_ADDED:
            videoQueue.addItem(payload);
            break;

          case types.VIDEO_REMOVED:
            videoQueue.removeItem(payload);
            break;
        }

        next(action); // Auto-play handling

        var isAutoPlay = videoPlayMode === _videoPlayModes["default"].autoPlay || videoPlayMode === _videoPlayModes["default"].refactoredAutoPlay;
        var indexToPlay = null;

        if (utils.isEditor() && payload !== -1) {
          stopPlaying();
        } else if (isAutoPlay) {
          switch (type) {
            case types.NAVIGATION_IN:
            case types.VIDEO_ENDED:
              playNextVideo();
              break;

            case types.EDITOR_MODE_CHANGED:
            case types.GALLERY_WINDOW_LAYOUT_CHANGED:
              indexToPlay = videoQueue.isCurrentVideoVisible() ? playCurrentVideo() : playNextVideo();
              break;

            case types.VIDEO_ADDED:
              playCurrentVideo();
              break;

            default:
              break;
          }
        }
      };
    };
  };
};

exports["default"] = _default;